import { AdvancedProgressIndicator, ProgressSegment } from '../advanced_progress_indicator/AdvancedProgressIndicator';

type ProgressIndicatorProps = {
    id: string;
    total: number;
    completed: number;
    completedColor?: string;
};

export function ProgressIndicator({ id, total, completed, completedColor }: ProgressIndicatorProps) {
    if (total === 0) return null;

    const isComplete = completed === total;
    const color = completedColor ?? (isComplete ? '#4caf50' : '#3a7bc8');

    const segments: ProgressSegment[] = [
        { label: 'Completed', count: completed, color },
    ];

    return (
        <AdvancedProgressIndicator
            id={id}
            segments={segments}
            total={total}
        />
    );
}
